import { render, staticRenderFns } from "./studentBill.vue?vue&type=template&id=29dfa541&scoped=true"
import script from "./studentBill.vue?vue&type=script&lang=js"
export * from "./studentBill.vue?vue&type=script&lang=js"
import style0 from "./studentBill.vue?vue&type=style&index=0&id=29dfa541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dfa541",
  null
  
)

export default component.exports